import { fetchPersonal } from 'helpers/fetch';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const Comprobante = () => {
    const useQuery = () => new URLSearchParams(useLocation().search);
    const ref = useQuery().get('ref');
    
    const [error, setError] = useState({ error: false, message: '' });
    const [loadingData, setLoadingData] = useState(true);


    useEffect(() => {
        if (!ref || !RegExp(/\d{20}/).test(ref)) return;
        loadData(ref);
    }, [ref]);

    async function loadData(ref) {
        const resp = await fetchPersonal(
            'esefinagetws.php',
            {
                "Oficina": "TRAMITES",
                "Peticion": "ReferenciaPagada",
                "Referencia": ref
            },
            'POST'
        );

        if (resp.status !== 200) {
            const message = (await resp.json()).detalle;
            setError({ error: true, message: message });
            return;
        }

        const { datosRecibo, arCuentas, datosBanco:referencia } = await resp.json();
        await loadPDF({datosRecibo, arCuentas, referencia})
        setLoadingData(false);


    }
    const loadPDF = async (data) => {
    }

    if (!ref) {
        return (
            <div>
                Referencia no ingresada
            </div>
        );
    }

    if (!ref || !RegExp(/\d{20}/).test(ref)) {
        return <div>Referencia no valida</div>
    }

    if (error.error) return (
        <div>
            {error.message}
        </div>
    )

    if (loadingData) {
        return (<div>cargando...</div>);
    }

    return (
        <div>
            comprobante print {ref}
        </div>
    )
}

export default Comprobante
